import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import * as PropTypes from 'prop-types';

var IconSize = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 'cover'];
var Icon = function Icon(_a) {
  var appearance = _a.appearance,
      extraClasses = _a.extraClasses,
      InlineIcon = _a.InlineIcon,
      size = _a.size,
      title = _a.title,
      ariaHidden = _a["aria-hidden"],
      ariaLabel = _a["aria-label"],
      rest = __rest(_a, ["appearance", "extraClasses", "InlineIcon", "size", "title", 'aria-hidden', 'aria-label']);

  var DEFAULT_SPACING_MULTIPLIER = 6;

  var customStyle = __assign({}, rest).style; // since the styles are minimal we can inline them minimizing 3rd party packages footprint and avoid CSS loading


  var styles = {
    display: 'inline-block',
    width: '20px',
    height: '20px',
    verticalAlign: 'middle',
    fill: 'currentColor'
  };

  if (size) {
    styles = __assign(__assign({}, styles), {
      width: size !== 'cover' ? "var(--hcr-spacing-".concat(size, ", ").concat(size * DEFAULT_SPACING_MULTIPLIER, "px)") : '100%',
      height: size !== 'cover' ? "var(--hcr-spacing-".concat(size, ", ").concat(size * DEFAULT_SPACING_MULTIPLIER, "px)") : '100%'
    });
  }

  if (appearance === 'primary') {
    styles = __assign(__assign({}, styles), {
      fill: "var(--hcr-icon-primary-color, var(--hcr-primary-icon-color, #8b8b8b))"
    });
  }

  if (appearance === 'secondary') {
    styles = __assign(__assign({}, styles), {
      fill: "var(--hcr-icon-secondary-color, var(--hcr-secondary-icon-color, #31a100))"
    });
  } // merging custom styles with component ones


  if (customStyle) {
    styles = __assign(__assign({}, styles), customStyle);
  }

  return /*#__PURE__*/React.createElement("span", __assign({
    className: "hci-icon ".concat(extraClasses)
  }, rest, {
    style: styles
  }), InlineIcon && /*#__PURE__*/React.createElement(InlineIcon, {
    title: title,
    role: "img",
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    style: {
      display: 'block',
      maxWidth: '100%'
    }
  }));
};
Icon.displayName = 'Icon';
Icon.defaultProps = {
  appearance: null,
  extraClasses: '',
  size: null,
  title: null,
  'aria-hidden': null,
  'aria-label': null
};
Icon.propTypes = {
  appearance: PropTypes.oneOf(['primary', 'secondary', null]),

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** An inline SVG icon from components/icons/inline */
  InlineIcon: PropTypes.func.isRequired,

  /** Size of the icon, 20px if none is provided, "cover" fills all available space */
  size: PropTypes.oneOf(IconSize),

  /** Custom title for Icon */
  title: PropTypes.string,

  /** Aria-hidden attribute for Icon */
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['true', 'false'])]),

  /** Aria Label for Icon */
  'aria-label': PropTypes.string
};

export { Icon, Icon as default };
